<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group :submissionId="submissionId" />
      <hr />
      <div v-if="samples && samples.length">
        <template v-for="(sample, index) in samples">
          <project-septic-sample-form-group
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            @updateSampleList="updateSampleList"
          />
        </template>
      </div>
      <b-row class="mt-3" align-h="end">
        <b-col cols="2">
          <b-button @click="updateSampleList('add')" variant="success" block>
            <i class="fa fa-plus" /> Add Sample
          </b-button>
        </b-col>
      </b-row>
      <hr />
      <turn-around-select
        :submissionId="submissionId"
        :turnArounds="turnArounds"
      />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(serviceQuestion, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="serviceQuestion" />
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectSepticSampleFormGroup from "./ProjectSepticSampleFormGroup";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectSubmissionSepticForm",
  components: {
    ProjectFieldFormGroup,
    ProjectSepticSampleFormGroup,
    TurnAroundSelect,
  },
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    turnArounds: {
      type: Array,
      default: () => [],
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    isValid() {
      return this.$v && !this.$v.$invalid;
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    updateSampleList(action, id) {
      const lastSample = this.samples[this.samples.length - 1];
      let listUpdate;
      switch (action) {
        case "add":
          listUpdate = [
            ...this.samples,
            {
              ...lastSample,
              test_package_sample_id: this.$uuid.v4(),
              identifier: `Sample ${this.samples.length + 1}`,
              sample_septic: { ...lastSample.sample_septic },
            },
          ];
          break;
        case "remove":
          listUpdate = this.samples.filter(
            (sample) => sample.test_package_sample_id !== id
          );
          break;
        default:
      }
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: listUpdate,
        name: "samples",
      });
    },
  },
};
</script>
